import React from 'react';
import './Homepage.css'; 
import logo from '../../assets/logo/LogoOnly.png'

const Homepage = () => {
  return (
    <div className="homepage-container">
      <div className="logo-container">
        <img src={logo} alt="MedicKit Logo" className="logo-homepage" />
      </div>
      <div className="welcome-message">
        <h1>
          Welcome to 
          MedicKit,<br />
          Drug Inventory and
          Seamless Tracking System
        </h1>
      </div>
    </div>
  );
}

export default Homepage;
